import React, { useEffect, useState } from 'react';
import { BundleProps, ProductData } from 'utils/types';
import { StyledGhostBundle } from 'templates/Bundles/GhostStudio/style';
import { EBadgeType, EBundlesInternalViewModel } from 'utils/enums';
import { BundlePrice } from 'components/BundlePrice';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { BadgeData, IEmblemBadge } from 'components/Badge/types';
import { GhostSaleBadge } from 'components/Badge/Sale/GhostSaleBadge';
import { useGetBadge } from 'utils/useGetBadge';

export const GhostBundle: React.FC<BundleProps> = ({
  prices,
  productList,
  backgroundSrc,
  backgroundColor = { colorOne: '#880000' },
  salePercentage = 0,
  salePercentageDisplayType,
  bundleButtonTextColor,
  bundleButtonColor,
  badges = [],
  emblemBadges = [],
}) => {
  const [mainProduct, setMainProduct] = useState<ProductData | null>(null);
  const [subProducts, setSubProducts] = useState<ProductData[]>([]);
  const [emblemBadgeOld, setEmblemBadgeOld] = useState<any>(null);
  const emblemBadgeNew = useGetBadge<IEmblemBadge>(emblemBadges);

  useEffect(() => {
    if (Array.isArray(badges) && badges.length > 0) {
      const foundEmblem = badges?.find((b: BadgeData) => {
        return (
          b.badge?.type === EBadgeType.EMBLEM || b.type === EBadgeType.EMBLEM
        );
      });
      setEmblemBadgeOld(foundEmblem?.badge?.emblem || foundEmblem?.emblem);
    } else {
      setEmblemBadgeOld(null);
    }
  }, [badges]);

  const emblemBadge = emblemBadgeNew ?? emblemBadgeOld;

  useEffect(() => {
    if (!productList || productList.length === 0) return;

    setMainProduct(productList[0]);

    setSubProducts(productList.slice(1, 5));
  }, [productList]);

  return (
    <StyledGhostBundle
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
    >
      <div className="container">
        {emblemBadge && (
          <div className="ghost-emblem">
            <img
              className="ghost-emblem--badge"
              alt="emblem-badge"
              src={emblemBadge.imageUrl}
            />
          </div>
        )}
        {salePercentage > 0 && (
          <GhostSaleBadge
            salePercentage={salePercentage}
            salePercentageDisplayType={salePercentageDisplayType}
          />
        )}
        {mainProduct && (
          <div className="main-product--image">
            <img
              className="image"
              src={mainProduct.images.product}
              alt="main-coin"
            />
          </div>
        )}
        <div className="products">
          <div className="top-container">
            <div className="main-product">
              {mainProduct && (
                <div className="main-product--amount">
                  <AutoTextSize
                    as="div"
                    mode="oneline"
                    maxFontSizePx={28}
                    minFontSizePx={4}
                    className="main-product--amount-price"
                    data-text={mainProduct.quantityDisplay}
                  >
                    {mainProduct.quantityDisplay}
                  </AutoTextSize>
                  {salePercentage > 0 && mainProduct?.strokedSaleQuantity && (
                    <div className="main-product--stroked">
                      {mainProduct.strokedSaleQuantity}
                    </div>
                  )}
                </div>
              )}
              <div className="price-container">
                <BundlePrice
                  buttonTextColor={bundleButtonTextColor}
                  buttonColor={bundleButtonColor}
                  prices={prices}
                  type={EBundlesInternalViewModel.GHOST}
                  isTextAutoResized
                />
              </div>
            </div>
          </div>
          {subProducts.length > 0 && (
            <div className="sub-products">
              {subProducts.map((product, i) => (
                <div
                  className="sub-product"
                  key={i}
                  style={{
                    color: product.textFontColorHex || '#FFF',
                  }}
                >
                  <img
                    className="sub-product--image"
                    src={product.images.product}
                    alt=""
                  />
                  <div className="sub-product--amount">
                    {product.quantityDisplay}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </StyledGhostBundle>
  );
};
